import StoreType from '@/typings/storeType';
(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('NavCtrl', navCtrl);

    function navCtrl($scope, $rootScope, $mdDialog, AuthService) {
        $scope.showStoresApp = false;
        // By the moment analytics dashboard will be hidden
        $scope.showAnalytics = false;

        $rootScope.$watch('user', () => {
            $scope.refreshIcons();
        });

        $scope.refreshIcons = function () {
            const accesRoles = $scope.user ? $scope.user.AccessRoles.Serialized.split(',') || [] : [];
            if (
                $scope.user &&
                (($scope.user.Stores &&
                    $scope.user.Stores.filter(
                        (s) =>
                            s.Type === StoreType.Shopify ||
                            s.Type === StoreType.WooCommerce ||
                            s.Type === StoreType.Etsy ||
                            s.Type === StoreType.Shoplazza ||
                            s.Type === StoreType.Amazon
                    ).length) ||
                    accesRoles.includes('custom-store'))
            ) {
                $scope.showStoresApp = true;
            } else {
                $scope.showStoresApp = false;
            }
        };

        $scope.logOut = function () {
            const confirm = $mdDialog
                .confirm()
                .title('Logout')
                .textContent('Do you want to logout?')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(() => {
                AuthService.logout();

                // Clear user data
                $rootScope.user = undefined;
            });
        };
    }
})();
